<template>
  <div class="about">
    <div class="about__container _container">
      <h1 class="about__title main-title _blue">
        {{ aboutPage.title[$lang] }}
      </h1>
      <div
        class="about__body"
        :class="{ about__vacancies: aboutPage.id === 9 }"
      >
        <swiper
          v-if="aboutPage.id != 10 && aboutPage.id != 9"
          :slidesPerView="1"
          :pagination="{ clickable: true }"
          :effect="'fade'"
          :speed="400"
          class="about__swiper"
        >
          <swiper-slide class="_ibg" v-if="aboutPage.id == 6">
            <!-- <img
              src="@/assets/images/corp.avif"
              alt=""
            /> -->
          </swiper-slide>
          <swiper-slide class="_ibg" v-if="aboutPage.id == 7">
            <!-- <img
              src="@/assets/images/corp1.jpg"
              alt=""
            /> -->
          </swiper-slide>
        </swiper>

        <div class="about__map responsiveMap" v-if="aboutPage.id === 10">
          <iframe style="height:450;width:650;border:0;" frameborder="0" src="https://www.google.com/maps/embed/v1/place?q=Aport+Mall+East,+Алматы,+Казахстан&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
        </div>
        <div class="about__content">
          <div class="about__info" v-html="aboutPage.description[$lang]"></div>
          <div class="about__contacts" v-if="aboutPage.id === 6">
            <div class="about__contact">
              <span class="about__icon">
                <img src="@/assets/icons/blue-phone.svg" alt="" />
              </span>
              312-15-11
            </div>
            <div class="about__contact">
              <span class="about__icon">
                <img src="@/assets/icons/blue-phone.svg" alt="" />
              </span>
              +7(705)-990-09-94 Эльвира
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, EffectFade, EffectCoverflow } from "swiper";
import { mapState, mapActions } from "vuex";

SwiperCore.use([Pagination, EffectFade]);
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [EffectCoverflow, Pagination],
    };
  },
  data() {
    return {
      slides: [
        require("@/assets/images/corporative-clients/01.jpg"),
        require("@/assets/images/corporative-clients/01.jpg"),
        require("@/assets/images/corporative-clients/01.jpg"),
        require("@/assets/images/corporative-clients/01.jpg"),
      ],
      map: false,
    };
  },
  computed: {
    ...mapState(["aboutPageId", "footer"]),
    aboutPage() {
      return this.footer.about.find(
        (item) => item.slug === this.$route.params.id
      );
    },
  },
  created() {
    this.fetchFooter();
  },
  methods: {
    ...mapActions(["fetchFooter"]),
  },
};
</script>

<style lang="scss">
.about {
  padding: 100px 0 130px 0;
  background: #44C45F;
  @media (max-width: $mobileSmall + px) {
    padding: 32px 0;
  }
  @media (max-width: 991.98px) {
    padding: 65px 0;
  }

  &__title {
    margin: 0 0 150px 0;
    @media (max-width: $tablet + px) {
      margin: 0 0 107px 0;
    }
    @media (max-width: $mobileSmall + px) {
      margin: 0 0 71px 0;
    }
  }

  &__body {
    @media (min-width: $tablet + px) {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: row-reverse;
      gap: 0 40px;
    }
  }

  &__vacancies {
    @media (min-width: $tablet + px) {
      display: block;
      max-width: 645px;
      margin: 0 auto;
      text-align: center;
    }
  }

  &__content {
    flex: 0 1 620px;
  }

  &__info {
    margin: 0 0 16px 0;
    font-weight: 400;
    font-size: 18px;
    line-height: 138.888%;
    letter-spacing: 0.02em;
    color: #2c3131;

    p {
      text-align: justify;
      &:not(:last-child) {
        margin: 0 0 12px 0;
      }
    }

    @media (max-width: $tablet + px) {
      font-size: 16px;
      margin: 0 0 14px 0;
    }
    @media (max-width: $mobileSmall + px) {
      font-size: 14px;
      line-height: 118.75%;
      text-align: center;
      margin: 0 0 12.5px 0;
    }
  }

  &__contacts {
    @media (max-width: $mobile) {
      width: fit-content;
      margin: 0 auto;
    }
  }

  &__contact {
    font-weight: 400;
    font-size: 18px;
    line-height: 138.8888%;
    letter-spacing: 0.02em;
    color: #2c3131;
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin: 0 0 16.5px 0;
    }

    @media (max-width: $tablet + px) {
      font-size: 16px;
    }
    @media (max-width: $mobileSmall + px) {
      font-size: 14px;
      &:not(:last-child) {
        margin: 0 0 13px 0;
      }
    }
  }

  &__icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin: 0 12px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 18px;
      height: 18px;
    }

    @media (max-width: $tablet + px) {
      width: 22px;
      height: 22px;
      margin: 0 8px 0 0;
      img {
        width: 16px;
        height: 16px;
      }
    }
    @media (max-width: $mobileSmall + px) {
      width: 20px;
      height: 20px;
      margin: 0 5px 0 0;
      img {
        width: 15px;
        height: 15px;
      }
    }
  }

  &__swiper {
    width: 536px;
    height: 600px;
    margin: 0;
    @media (max-width: 1366.98px) {
      width: 436px;
      height: 500px;
    }
    @media (max-width: 991.98px) {
      margin: 0 auto;
    }
    @media (max-width: 767.98px) {
      width: 306px;
      height: 350px;
    }
    @media (max-width: 479.98px) {
      width: 206px;
      height: 256px;
    }

    .swiper-slide {
      border: 3px solid #eaeef5;
      border-radius: 60px;
      height: 501px;
      overflow: hidden;
      @media (max-width: 1366.98px) {
        height: 401px;
      }
      @media (max-width: 767.98px) {
        height: 306px;
        border-radius: 15px;
        border-width: 2px;
      }
      @media (max-width: 479.98px) {
        height: 206px;
      }
    }

    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      bottom: 45.83px;
      @media (max-width: 767.98px) {
        bottom: 22.92px;
      }
    }

    .swiper-pagination-bullet {
      width: 8.33px;
      height: 8.33px;
      margin: 0 12.5px !important;
      background: #b3b3bb;
      opacity: 1;

      &-active {
        background: #4745B0;
      }

      @media (max-width: 767.98px) {
        margin: 0 6.25px !important;
        width: 4.17px;
        height: 4.17px;
      }
    }
  }

  &__map {
    width: 536px;
    height: 501px;
    @media (max-width: $laptop + px) {
      width: 450px;
      height: 401px;
    }
    @media (max-width: $tablet + px) {
      margin: 0 auto 50px;
    }
    @media (max-width: 479.98px) {
      width: 100%;
      margin: 0 auto 24px;
    }
  }
}
</style>
